import store from "../../index.js";
import api from "../../../utils/api";

export const modules = {
  store,
};

export const state = {
  _inquiry: {
    list: [],
    process: null,
  },
  _error: { code: 0, message: "" },
};

export const mutations = {
  setReportBuyInquiry(state, response) {
    state._inquiry = {
      list: [],
      process: null,
    };
    state._inquiry.list = response;
  },
};

export const actions = {
  async acSendReportBuyInquiry({ commit }, payload) {
    const url = "/api/v1/report-buy/inquiry";
    try {
      const res = await api.post(url, {
        content: payload.content,
        user_role_type: payload.user_role_type,
        report_seq: payload.report_seq,
      });
      return res?.data?.code === 0;
    } catch (error) {
      return false;
    }
  },

  async acGetReportBuyInquiry({ commit }, payload) {
    const url = "/api/v1/report-buy/inquiry";
    try {
      const res = await api.get(url, {
        params: {
          report_seq: payload,
        },
      });
      commit("setReportBuyInquiry", res?.data?.data);
      return res?.data?.code === 0;
    } catch (error) {
      return false;
    }
  },
};

export const getters = {
  geCodeFail: (state) => {
    switch (state._error.code) {
    }
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
